export const selectConfig = {
  search: true, // true/false for the search functionlity defaults to false,
  placeholder: "Search", // text to be displayed when no item is selected defaults to Select,
  // limitTo: 5, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
  noResultsFound: "No results found!", // text to be displayed when no items are found while searching
  searchPlaceholder: "search",
  displayKey: "name",
};
export const ngMutliSeltSettings = {
  singleSelection: false,
  idField: "id",
  textField: "name",
  selectAllText: "Select All",
  unSelectAllText: "UnSelect All",
  itemsShowLimit: 2,
  allowSearchFilter: true,
}

export const convertObjToArray = (obj: object) => {
  let array = [];
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const element = obj[key];
      array.push(element);
    }
  }
  return array;
};
export const comparer = (otherArray, opt?: { arr1Key?: string, arr2Key?: string }) => {
  const otherKey = opt && opt.arr1Key ? opt.arr1Key : 'id';
  const currentKey = opt && opt.arr2Key ? opt.arr2Key : 'id';
  return function (current) {
    return (
      otherArray.filter(function (other) {
        return other[otherKey] == current[currentKey];
      }).length == 0
    );
  };
};
export const userDetails = {
  orgId: 1,
  teamId: 25,
};
export const getPrtyColor = (prty) => {
  switch (prty) {
    case "HIGH":
      return "text-danger";
    case "LOW":
      return "text-primary";
    case "MEDIUM":
      return "text-info";
    case "URGENT":
      return "text-danger";
    default:
      return "text-secondary";
  }
};

export const addDays = (days) => {
  let date = new Date();
  date.setDate(date.getDate() + days);
  return date;
};

export const exportTableToCSV = (
  data: any[],
  columns: { value: string; title: string }[],
  filename
) => {
  // Nathan Apis - fix output date
  if (data[0].createdOn) {
    data = data.map((res: any) => {
      if (res.paymentDueDate) {
        res.paymentDueDate = new Date(res.paymentDueDate).toDateString();
      }
      if (res.endDate) {
        res.endDate = new Date(res.endDate).toDateString();
      }
      res.createdOn = new Date(res.createdOn).toDateString();

      return res;
    });
  }
  if (data[0] && data[0].orderDate && data[0].estimatedDeliveryDate) {
    data = data.map((res: any) => {
      if (res.orderDate)
        res.orderDate = new Date(res.orderDate).toDateString();
      if (res.estimatedDeliveryDate)
        res.estimatedDeliveryDate = new Date(res.estimatedDeliveryDate).toDateString();
      return res;
    });

  }



  let newData = [];
  data.forEach((dat) => {
    newData.push(columns.map((col) => `"${dat[col.value]}"`).join(","));
  });
  newData = [columns.map((col) => col.title).join(","), ...newData];
  downloadCSV(newData.join("\n"), `${filename}.csv`);
};

export const exportTableToCSV2 = (
  data: any[],
  columns: { key: string; title: string, canNotExport?: boolean, overrideTransformForExport?: boolean, transform?: (value: any) => any }[],
  filename
) => {
  // Nathan Apis - fix output date

  data = data.map((res: any) => {
    if (res.paymentDueDate) {
      res.paymentDueDate = new Date(res.paymentDueDate).toDateString();
    }
    if (res.endDate) {
      res.endDate = new Date(res.endDate).toDateString();
    }
    if (res.createdOn) {
      res.createdOn = new Date(res.createdOn).toDateString();
    }
    if (res.orderDate) {
      res.orderDate = new Date(res.orderDate).toDateString();
    }
    if (res.estimatedDeliveryDate) {
      res.estimatedDeliveryDate = new Date(res.estimatedDeliveryDate).toDateString();
    }
    return res;
  })

  let newData = [];
  data.forEach((dat) => {
    let newRow = [];
    columns.forEach((col) => {
      if (col.canNotExport) return;
      if (!Object.prototype.hasOwnProperty.call(dat, col.key)) return;
      if (!col.overrideTransformForExport && col.transform) {
        newRow.push(col.transform(dat[col.key]));
      } else {
        newRow.push(dat[col.key]);
      }
    })
    newData.push(newRow.join(","));
  });
  newData = [columns.map((col) => col.title).join(","), ...newData];
  downloadCSV(newData.join("\n"), `${filename}.csv`);
};

export const downloadCSV = (csv, filename) => {
  var csvFile;
  var downloadLink;
  // CSV file
  csvFile = new Blob([csv], { type: "text/csv" });
  // Download link
  downloadLink = document.createElement("a");

  // File name
  downloadLink.download = filename;

  // Create a link to the file
  downloadLink.href = window.URL.createObjectURL(csvFile);

  // Hide download link
  downloadLink.style.display = "none";

  // Add the link to DOM
  document.body.appendChild(downloadLink);

  // Click download link
  downloadLink.click();
};

export const getPageCountUtil = (data: { pageNumber: number; pageSize: number; dataLength: number; totalItems?: number }) => {
  if (!data) return 0;
  const { pageNumber = 1, pageSize = 10, dataLength = 0, totalItems } = data;
  if (totalItems != null && totalItems >= 0) {
    return totalItems === 0 ? 0 : Math.min(pageNumber * pageSize, totalItems);
  }
  return dataLength > 0 ? (pageNumber - 1) * pageSize + dataLength : 0;
};

export function extractDeepPropertyByMapKey(obj: any, map: string): any {
  const keys = map.split(".");
  const head = keys.shift();

  return keys.reduce((prop: any, key: string) => {
    return !isUndefined(prop) && !isNull(prop) && !isUndefined(prop[key])
      ? prop[key]
      : undefined;
  }, obj[head || ""]);
}

export function isUndefined(value: any) {
  return typeof value === "undefined";
}

export function isNull(value: any) {
  return value === null;
}

export function toCamelCase(str) {
  return str
    .split(" ")
    .map(function (word, index) {
      // If it is the first word make sure to lowercase all the chars.
      if (index == 0) {
        return word.toLowerCase();
      }
      // If it is not the first word only upper case the first char and lowercase the rest.
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join("");
}

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const getClientRecords = (res: any): any[] => {
  const payload = res && typeof res === "object" ? res.payload : res;
  if (Array.isArray(payload)) {
    return payload.filter((record) => !!record && typeof record === "object");
  }
  if (payload && typeof payload === "object") {
    return [payload];
  }
  return [];
};

const cleanNameValue = (value: any): string => {
  if (typeof value !== "string" && typeof value !== "number") {
    return "";
  }
  const trimmed = String(value).trim();
  const lower = trimmed.toLowerCase();
  if (!trimmed || lower === "none" || lower === "undefined" || lower === "null") {
    return "";
  }
  return trimmed;
};

const nameOfRecord = (record: any): string => {
  if (!record || typeof record !== "object") {
    return "";
  }
  const direct =
    cleanNameValue(record.name) ||
    cleanNameValue(record.companyName) ||
    cleanNameValue(record.displayName);
  if (direct) {
    return direct;
  }
  const first =
    cleanNameValue(record.firstName) || cleanNameValue(record.firstname);
  const last =
    cleanNameValue(record.surName) ||
    cleanNameValue(record.lastName) ||
    cleanNameValue(record.lastname);
  if (first || last) {
    return (first + " " + last).trim();
  }
  return "";
};

const recordBelongsToClient = (record: any, clientId: any): boolean => {
  if (clientId === undefined || clientId === null || clientId === "") {
    return false;
  }
  const id = String(clientId);
  return (
    String(record.clientId) === id ||
    String(record.id) === id ||
    String(record._id) === id
  );
};

export function getClientRecord(res: any, clientId?: any): any {
  const records = getClientRecords(res);
  if (!records.length) {
    return null;
  }
  for (let i = 0; i < records.length; i++) {
    if (recordBelongsToClient(records[i], clientId)) {
      return records[i];
    }
  }
  return records[0];
}

export function getClientDisplayName(
  res: any,
  clientId?: any,
  storedName?: any
): string {
  const stored = cleanNameValue(storedName);
  if (stored) {
    return stored;
  }
  const records = getClientRecords(res);
  for (let i = 0; i < records.length; i++) {
    if (recordBelongsToClient(records[i], clientId)) {
      const matchedName = nameOfRecord(records[i]);
      if (matchedName) {
        return matchedName;
      }
      break;
    }
  }
  for (let i = 0; i < records.length; i++) {
    const recordName = nameOfRecord(records[i]);
    if (recordName) {
      return recordName;
    }
  }
  return "";
}
